<script>

import { Overlay } from '../../'

export default {
    name: 'KST',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'Know Sure Things',
                preset: {
                    name: 'KST',
                    side: 'offchart',
                    settings: {
                        lineWidth: 0.75,
                        colors: ["#009688", "#F44336"]
                    }
                }
            }
        },
        use_for() { return ['KST'] },
        calc() {
            return {
                props: {
                    roc1: { def: 10, text: 'ROC Length # 1' },
                    roc2: { def: 15, text: 'ROC Length # 2' },
                    roc3: { def: 20, text: 'ROC Length # 3' },
                    roc4: { def: 30, text: 'ROC Length # 4' },
                    sma1: { def: 10, text: 'SMA # 1' },
                    sma2: { def: 10, text: 'SMA # 2' },
                    sma3: { def: 10, text: 'SMA # 3' },
                    sma4: { def: 15, text: 'SMA # 4' },
                    len: { def: 10, text: 'Signal Length' }
                },
                conf: { renderer: 'Splines' },
                update: `
                    let [kst, signal] = kst(roc1, roc2, roc3, roc4, sma1, sma2, sma3, sma4, len)
                    return [kst[0], signal[0]]
                `
            }
        }
    }
}
</script>
